import { ContentCopy, ExpandMore } from '@mui/icons-material'
import { Accordion, AccordionDetails, AccordionSummary, Box, Card, Divider, IconButton, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'

const LogRow = ({ log, handleClick }) => {
    const [jsonObject, setJsonObject] = useState("")
    const parseJson = (() => {
        try {
            setJsonObject(JSON.parse(log.request));
        } catch (err) {
            setJsonObject(log.request)
        }
    })
    useEffect(() => {
        parseJson()
    }, [])

    const beautifiedString = JSON.stringify(jsonObject, null, 2);
    return (
        <Card sx={{ my: 1, border: "2px solid grey" }}>
            <Accordion >
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                >
                    <Box onClick={(e) => e.stopPropagation()} // Stop event propagation
                        display={"flex"} justifyContent={"center"} gap={2} flexWrap={"wrap"}>
                        <span style={{ color: "black", display: "flex", alignItems: "center", fontWeight: 600 }}>
                            LogId: {log.logId}
                        </span>
                        <span style={{ color: "#2065d1", display: "flex", alignItems: "center", fontWeight: 600 }}>
                            Sender: {log.sender} <IconButton sx={{ color: "#2065d1" }} onClick={() => { navigator.clipboard.writeText(log.sender); handleClick() }}><ContentCopy /></IconButton>
                        </span>
                        <span style={{ color: "green", display: "flex", alignItems: "center", fontWeight: 600 }}>
                            SyncType: {log.syncType}
                        </span>
                        <span style={{ color: "#f03e30", display: "flex", alignItems: "center", fontWeight: 600 }}>
                            Vhost: {log.vhost} <IconButton sx={{ color: "#f03e30" }} onClick={() => { navigator.clipboard.writeText(log.vhost); handleClick() }}><ContentCopy /></IconButton>
                        </span>
                    </Box>

                </AccordionSummary>
                <AccordionDetails>
                    <Divider sx={{ mb: 2 }} />
                    <IconButton onClick={() => { navigator.clipboard.writeText(beautifiedString); handleClick() }}><ContentCopy /></IconButton>
                    <pre style={{ fontSize: "13px" }}>
                        {beautifiedString}
                    </pre>

                </AccordionDetails>
            </Accordion>
        </Card>

    )
}

export default React.memo(LogRow, (p, n) => p.log === n.log)